
import Answer from './answer.vue'
import Modify from './modify.vue'
import AiSugggestion from '../ai-suggestion.vue'
import AiEditor from '../ai-editor.vue'
import Cards from 'components/cards'
import {computed} from 'vue'
import AiInput from './ai-input'
import AiFile from '../ai-file'
import AnswerTabs from './answer-tabs.vue'
import SaveDoc from 'components/cards/save-doc.vue'
// import AiLogo from '../ai-logo.vue'

export default {
  components: {
    SaveDoc,
    Answer,
    AiEditor,
    Cards, 
    AiSugggestion, 
    Modify,
    AiInput,
    AiFile,
    AnswerTabs
  },
  provide() {
    return {
      di_sources: computed(() => this.sources),
    }
  },
  props: {
    chatId: {type: String, required: true},
    item: {type: Object, required: true},
    generating: {type: Boolean, default: false},
    lastAnswer: {type: Boolean, default: false},
    readonly: {type: Boolean, default: false},
    restricted: {type: Boolean, default: false},
  },
  emits: ['ask-ai', 'text-added', 'like', 'dislike', 'refrag', 'save', 'follow-person', 'follow-company'],
  data() {
    return {
      typing: false,
    }
  },
  computed: {
    internal(){
      return this.item.data?.internal
    },
    cards() {
      return this.item.data?.cards
    },
    suggestions() {
      return this.item.data?.suggestions
    },
    is_editor() {
      return !this.readonly && this.lastAnswer && this.item.data?.editable
    },
    inline_btns() {
      return this.item.data?.inline_btns
    },
    input() {
      return this.item.data?.input
    },
    file_download(){
      return this.item.data?.file_download
    },
    intermediate(){
      return !!this.item.intermediate
    },
    self_loading(){
      return this.intermediate || this.typing
    },
    sources() {
      const items = this.item.data?.sources || []
      if (!this.self_loading && items.length === 0) 
        items.push({
          type: 'genrate',
          name: 'Genrate AI'
        })
      return items
    },
    liked(){
      return this.item.liked > 0
    },
    disliked(){
      return this.item.liked < 0
    }
  },
  created() {
    this.$listen('inline-button', this.onInlineButton)
  },
  methods: {
    async copyAnswer(){
      await this.$refs.answer.copyText()
    },
    onTextAdded(full) {
      this.typing = !full
      this.$nextTick(() => this.$emit('text-added', full))
    },
    onInlineButton(idx) {
      this.$emit('ask-ai', this.inline_btns[idx])
    },
    getAnswerTabs() {
      return this.$refs['answer-tabs']
    }
  }
}
